
// Set all of the colors here and update the css vars
// These colors map to the zeplin defined colors
// https://app.zeplin.io/project/5ffea29702627814f1355337
export const colors = {
    "golden-yellow": "#f9c32d",
    "red": "#e10505",
    "red-two": "#ff0000",
    "deep-orange": "#e65400",
    "dusty-orange": "#f67b2f",
    "wheat": "#f8d696",
    "light-grey": "#e7e8d5",
    "green-blue": "#01ab8b",
    "butterscotch": "#fab636",
    "bluegreen": "#008074",
    "dusk-blue": "#234483",
    "deep-aqua": "#0c637c",
    "slate": "#476475",
    "silver": "#d8e0e3",
    "dark-sky-blue": "#2da3d7",
    "aqua-marine": "#4fdbe7",
    "pale-olive-green": "#b3de68",
    "bluegrey": "#90b1c0",
    "black": "#000000",
    "white": "#ffffff",
    "white-two": "#f5f5f5",
    "white-three": "#f2f2f2",
    "darkish-purple": "#742068",
    "charcoal": "#50544d",
    "warm-grey": "#707070",
    "purplish-pink": "#d04d97",
    "silver-two": "#bdbebc",
    "greyish-blue": "#5c889c",
    "darkish-pink": "#A73B9D"
};


export const colorCssMapping = {
    "nav-menu-button-bg-color": colors["deep-orange"],
    "nav-bg-color": colors["black"],
    "nav-menu-text-color": colors["white"],
    "nav-menu-text-hover-color": colors["black"],
    "nav-menu-hover-bg-color": colors["white"],
    "nav-menu-traditional-bg": colors["darkish-purple"],
    "nav-menu-mbs-bg": colors["dusk-blue"],
    "nav-menu-raildocs-bg": colors["bluegreen"],
    "nav-menu-reporting-bg": colors["golden-yellow"],
    "nav-menu-fatigue-assessment-bg": colors["deep-orange"],
    "nav-menu-user-management-bg": colors["deep-aqua"],
    "nav-menu-apps-bg": colors["slate"],
    "nav-menu-quicklinks-bg": colors["charcoal"],
    "nav-menu-my-documents-bg": colors["light-grey"],
    "nav-menu-all-documents-bg": colors["deep-aqua"],
    "card-primary-bg": colors["white-two"],
    "text-color": colors["black"],
    "text-color-alternate": colors["white"],
    "text-primary-heading-underline": colors["dusty-orange"],
    "card-alternate-bg": colors["wheat"],
    "card-grid-border": colors["warm-grey"],
    "status-requires-action-color": colors["red"],
    "status-ok": colors["green-blue"],
    "favourites-color": colors.butterscotch,
    "rb-network-rules-color": colors.butterscotch,
    "rb-network-procs-color": colors["purplish-pink"],
    "rb-operating-notices-color": colors["silver-two"],
    "rb-network-rules-forms-color": colors["dark-sky-blue"],
    "rb-network-rail-traffic-operations-manual": colors["aqua-marine"],
    "rb-remote-control-signalling": colors["pale-olive-green"],
    "rb-glossary": colors["bluegrey"],
    "button-primary-color": colors["greyish-blue"],
    "rail-docs-menu": colors["slate"],
    "button-grid-icon": colors["slate"],
    "modal-header-color": colors["deep-orange"],
    "modal-sub-header-color": colors["greyish-blue"],
};

export const docViewMapping: { [id: string]: string; } = {
    "AllDocuments": colorCssMapping["nav-menu-all-documents-bg"],
    "MyDocuments": colorCssMapping["nav-menu-my-documents-bg"],
    "RailRulebookTaditional": colorCssMapping["nav-menu-traditional-bg"],
    "RailRulebookCBTC": colorCssMapping["nav-menu-mbs-bg"],
    "RailDocuments": colorCssMapping["nav-menu-raildocs-bg"],
};

export const configure = () => {
    for (const [key, value] of Object.entries(colors)) {
        document.documentElement.style.setProperty(`--${key}`, value);
    }

    // We loop through all the css vars and set them here
    for (const [key, value] of Object.entries(colorCssMapping)) {
        document.documentElement.style.setProperty(`--${key}`, value);
    }

}

